import React from 'react';
import { ExternalLink } from 'lucide-react';

const timelineEvents = [
  { 
    icon: 'https://customer-assets.emergentagent.com/job_4ebaa9cc-440b-4527-9761-4d4c07f094d6/artifacts/jeb66474_Icone%20Ce%CC%81re%CC%81monie.png',
    time: '17h30',
    title: 'Cérémonie', 
    description: 'Échange des vœux'
  },
  { 
    icon: 'https://customer-assets.emergentagent.com/job_4ebaa9cc-440b-4527-9761-4d4c07f094d6/artifacts/udjspgm1_Icone%20Cocktail.png',
    time: null,
    title: 'Cocktail', 
    description: 'Jardins de la Hacienda'
  },
  { 
    icon: 'https://customer-assets.emergentagent.com/job_4ebaa9cc-440b-4527-9761-4d4c07f094d6/artifacts/c9e2h1bf_Icone%20Diner.png',
    time: null,
    title: 'Dîner', 
    description: 'Banquet'
  },
  { 
    icon: 'https://customer-assets.emergentagent.com/job_4ebaa9cc-440b-4527-9761-4d4c07f094d6/artifacts/kwqar5dq_Icone%20Soire%CC%81e.png',
    time: null,
    title: 'Soirée', 
    description: 'Danse et célébration'
  },
];

export const WeddingPage = () => {
  return (
    <div className="min-h-screen pt-20" data-testid="wedding-page">
      {/* Header */}
      <section className="py-16 md:py-20 px-6 md:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="font-display text-5xl md:text-7xl mb-4 animate-fade-in text-[#e17c3b]">Le Grand Jour</h1>
          <p className="font-accent italic text-2xl text-[#8d5f3f]/70 animate-fade-in delay-100">
            L'Événement
          </p>
        </div>
      </section>

      {/* Two Blocks Section */}
      <section className="py-8 px-6 md:px-12" data-testid="info-blocks">
        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-2 gap-6">
            {/* Left Block - Date & Lieu */}
            <div 
              className="bg-[#fcf6f1] rounded-2xl p-8 md:p-10 animate-slide-up shadow-md text-center"
              data-testid="date-lieu-block"
            >
              <div className="space-y-6">
                <div>
                  <h3 className="font-display text-2xl md:text-3xl text-[#e17c3b] font-bold mb-3" data-testid="date-heure-title">Date & Heure</h3>
                  <p className="text-[#8d5f3f]">Dimanche 18 octobre 2026</p>
                  <p className="text-[#8d5f3f]">À partir de 17h30</p>
                </div>
                
                <div>
                  <h3 className="font-display text-2xl md:text-3xl text-[#e17c3b] font-bold mb-3" data-testid="adresse-title">Adresse</h3>
                  <p className="text-[#8d5f3f] font-medium text-lg">Hacienda El Vizir</p>
                  <p className="text-[#6b8e4e] text-sm mt-2">Ctra. Gines - Espartinas, km. 6</p>
                  <p className="text-[#6b8e4e] text-sm">41807 Espartinas</p>
                  <p className="text-[#6b8e4e] text-sm">Séville, Espagne</p>
                </div>
                
                <a 
                  href="https://www.google.com/maps/place/Hacienda+El+Vizir/@37.3952968,-6.1025839,17z/data=!3m1!4b1!4m6!3m5!1s0xd121362b30dde7b:0x68c68ec8b9660708!8m2!3d37.3952968!4d-6.100009!16s%2Fg%2F1tjxgxlm?entry=ttu&g_ep=EgoyMDI2MDIwOC4wIKXMDSoASAFQAw%3D%3D" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-[#e17c3b] hover:text-[#c96a2f] transition-colors font-medium"
                  data-testid="google-maps-link"
                >
                  <ExternalLink className="w-4 h-4" />
                  Voir sur Google Maps
                </a>
              </div>
            </div>

            {/* Right Block - Dress Code */}
            <div 
              className="bg-[#8d5f3f] rounded-2xl p-8 md:p-10 animate-slide-up delay-100 shadow-md text-center"
              data-testid="dress-code-block"
            >
              <div className="space-y-4">
                <h2 className="font-display text-2xl text-white">Dress Code</h2>
                
                <h3 className="font-accent italic text-3xl text-[#fcf6f1]">
                  "No White, White No"
                </h3>
                
                <p className="text-[#fcf6f1]/90 leading-relaxed">
                  Le blanc est réservé aux mariés.
                </p>
                
                <p className="text-[#fcf6f1]/90 leading-relaxed">
                  Merci d'éviter toute tenue blanche (robes, ensembles, costumes, etc.).
                </p>
                
                <p className="text-[#fcf6f1]/90 leading-relaxed">
                  Les chemises blanches sont autorisées.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Horizontal Timeline */}
      <section className="py-16 md:py-24 px-6 md:px-12" data-testid="wedding-timeline">
        <div className="max-w-5xl mx-auto">
          <h2 className="font-display text-3xl md:text-4xl text-center mb-16 text-[#8d5f3f]">Déroulement de la journée</h2>
          
          {/* Desktop Horizontal Timeline */}
          <div className="hidden md:block relative">
            {/* Connecting Line - Brown #8d5f3f */}
            <div className="absolute top-12 left-0 right-0 h-0.5 bg-[#8d5f3f]" />
            
            <div className="grid grid-cols-4 gap-4">
              {timelineEvents.map((event, index) => (
                <div 
                  key={event.title}
                  className="flex flex-col items-center text-center animate-slide-up"
                  style={{ animationDelay: `${index * 150}ms` }}
                  data-testid={`timeline-event-${index}`}
                >
                  {/* Icon Circle - White background */}
                  <div className="relative z-10 w-24 h-24 rounded-full bg-white border-2 border-[#8d5f3f] flex items-center justify-center shadow-md mb-4">
                    <img 
                      src={event.icon} 
                      alt={event.title}
                      className="w-12 h-12 object-contain"
                    />
                  </div>
                  
                  {/* Time (only when provided) */}
                  {event.time ? (
                    <p className="font-display text-2xl text-[#e17c3b] mb-2">{event.time}</p>
                  ) : (
                    <span className="block w-6 h-px bg-[#8d5f3f]/30 mb-4 mx-auto" />
                  )}
                  
                  {/* Title */}
                  <h3 className="font-display text-lg text-[#8d5f3f] mb-1">{event.title}</h3>
                  
                  {/* Description - Leaf Green */}
                  <p className="text-[#6b8e4e] text-sm">{event.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Mobile Vertical Timeline with connecting line */}
          <div className="md:hidden relative">
            {/* Vertical connecting line */}
            <div className="absolute left-8 top-8 bottom-8 w-0.5 bg-[#8d5f3f]" />
            
            <div className="space-y-8">
              {timelineEvents.map((event, index) => (
                <div 
                  key={event.title}
                  className="flex items-start gap-4 animate-slide-up relative"
                  style={{ animationDelay: `${index * 100}ms` }}
                  data-testid={`mobile-timeline-event-${index}`}
                >
                  {/* Icon */}
                  <div className="w-16 h-16 rounded-full bg-white border-2 border-[#8d5f3f] flex items-center justify-center shadow-md flex-shrink-0 relative z-10">
                    <img 
                      src={event.icon} 
                      alt={event.title}
                      className="w-8 h-8 object-contain"
                    />
                  </div>
                  
                  {/* Content */}
                  <div className="flex-1 pt-1">
                    {event.time ? (
                      <p className="font-display text-xl text-[#e17c3b]">{event.time}</p>
                    ) : (
                      <span className="block w-5 h-px bg-[#8d5f3f]/30 mb-1" />
                    )}
                    <h3 className="font-display text-lg text-[#8d5f3f]">{event.title}</h3>
                    <p className="text-[#6b8e4e] text-sm">{event.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Bottom Decorative Images - Le mariage 1 & 2 */}
      <section className="py-8 px-6 md:px-12" data-testid="wedding-bottom-images">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="rounded-2xl overflow-hidden shadow-lg">
              <img
                src="https://customer-assets.emergentagent.com/job_wedding-invite-gc/artifacts/edgkxm5k_Le%20mariage%201.jpeg"
                alt="Le mariage 1"
                className="w-full h-64 md:h-72 object-cover hover:scale-105 transition-transform duration-500"
                loading="lazy"
                decoding="async"
                data-testid="wedding-bottom-image-1"
              />
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg">
              <img
                src="https://customer-assets.emergentagent.com/job_wedding-invite-gc/artifacts/tne6h2no_Le%20mariage%202.jpeg"
                alt="Le mariage 2"
                className="w-full h-64 md:h-72 object-cover hover:scale-105 transition-transform duration-500"
                loading="lazy"
                decoding="async"
                data-testid="wedding-bottom-image-2"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
